/**
 * Fubo Design System Layout Constants
 * Based on Figma Design System - Object styles
 * Last update: Friday, May 16, 2025 at 4:00PM ET
 */

export const borderRadius = {
  xs: '0.25rem', // 4px
  sm: '0.5rem', // 8px
  md: '0.75rem', // 12px
  lg: '1rem', // 16px
  circle: '31.25rem', // 500px
}

export const borderWidth = {
  none: '0px',
  xs: '1px',
  sm: '2px',
}

export const breakpoints = {
  mobile: 0, // Mobile-first (default)
  mobileMin: 375, // Mobile and up
  mobileMax: 599, // Mobile and up
  tablet: 768, // Tablet and up
  tabletMax: 992, // Tablet and up
  desktop: 1024, // Desktop and up
}

export const maxWidth = {
  desktop: '1400px',
  container: '800px',
}

// Helper function to generate media queries
export const mediaQuery = {
  mobileMin: `@media screen and (min-width: ${breakpoints.mobileMin}px)`,
  mobileMax: `@media screen and (min-width: ${breakpoints.mobileMax}px)`,
  tablet: `@media screen and (min-width: ${breakpoints.tablet}px)`,
  tabletMax: `@media screen and (min-width: ${breakpoints.tabletMax}px)`,
  desktop: `@media screen and (min-width: ${breakpoints.desktop}px)`,
}

export const fadeGradients = {
  hero: {
    small:
      'linear-gradient(90deg, #0B0C12 5.71%, rgba(11, 12, 18, 0.75) 49.98%, rgba(0, 15, 38, 0.00) 99.55%)',
    large:
      'linear-gradient(90deg, #0B0C12 10.33%, rgba(11, 12, 18, 0.80) 40.07%, rgba(0, 15, 38, 0.00) 84.53%)',
  },
  logo: {
    primary: 'rgba(11, 12, 18, 0.6)',
    secondary: 'linear-gradient(180deg, rgba(250, 251, 255, 0) 49%, rgba(250, 251, 255, 1) 84%)',
  },
  overlay: {
    card: 'linear-gradient(216deg, rgba(0, 2, 21, 0) 7%, rgba(0, 2, 21, 0.7) 21%, rgba(0, 2, 21, 1) 35%)',
    card2:
      'linear-gradient(210deg, rgba(0, 2, 21, 0) 10%, rgba(0, 2, 21, 0.7) 31%, rgba(0, 2, 21, 1) 55%)',
    video: 'rgba(11, 12, 18, 0.6)',
  },
}

export default {
  borderRadius,
  borderWidth,
  breakpoints,
  mediaQuery,
  fadeGradients,
}
